import { useState, useCallback } from 'react';


export const useTabs = () => {
  const [activeTab, setActiveTab] = useState('facebook');
  const [tabStates, setTabStates] = useState({
    facebook: {
      posts: [],
      hasNext: false,
      hasPrevFlag: false,
      limit: 10,
      offset: 0,
      cursor: null,
      nextCursor: null,
      prevCursors: [],
      loading: false,
      initialized: false
    },
    instagram: {
      posts: [],
      hasNext: false,
      hasPrevFlag: false,
      limit: 10,
      offset: 0,
      cursor: null,
      nextCursor: null,
      prevCursors: [],
      loading: false,
      initialized: false
    }
  });



  const switchTab = useCallback((tabName) => {
    if (tabName === activeTab) return;

    setActiveTab(tabName);
  }, [activeTab]);

  const updateTabState = useCallback((tabName, updates) => {
    setTabStates(prevStates => ({
      ...prevStates,
      [tabName]: {
        ...prevStates[tabName],
        ...updates
      }
    }));
  }, []);

  const getTabState = useCallback((tabName) => {
    return tabStates[tabName];
  }, [tabStates]);

  const getCurrentTabState = useCallback(() => {
    return tabStates[activeTab];
  }, [tabStates, activeTab]);

  const resetTabState = useCallback((tabName) => {
    const resetState = {
      posts: [],
      hasNext: false,
      hasPrevFlag: false,
      limit: 10,
      offset: 0,
      cursor: null,
      nextCursor: null,
      prevCursors: [],
      loading: false,
      initialized: false
    };

    updateTabState(tabName, resetState);
  }, [updateTabState]);

  const setTabLoading = useCallback((tabName, loading) => {
    updateTabState(tabName, { loading });
  }, [updateTabState]);

  const setTabPosts = useCallback((tabName, posts, pagination = {}) => {
    updateTabState(tabName, {
      posts,
      hasNext: pagination.hasNext || false,
      hasPrevFlag: pagination.hasPrevFlag || false,
      nextCursor: pagination.nextCursor || null,
      initialized: true
    });
  }, [updateTabState]);

  const setTabPagination = useCallback((tabName, paginationData) => {
    updateTabState(tabName, paginationData);
  }, [updateTabState]);

  return {
    activeTab,
    tabStates,
    switchTab,
    updateTabState,
    getTabState,
    getCurrentTabState,
    resetTabState,
    setTabLoading,
    setTabPosts,
    setTabPagination
  };
};